import { isDefined } from './helpers';
import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"
import createStore from './state';
import { getClass, getMonth, getDateKey } from './calendar';
import ClbsCustomMulipleSelect from './clbs_custom_select';

function initState(initialState)
{
    const baseState = initialState;
    const reducer = (state, action) => {
        switch (action.type) {
            case 'setPrice':
                return { ...state, price: action.price };
            case 'setDays':
                return { ...state, days: action.days };
            case 'setTaxe':
                return { ...state, taxe: action.taxe };
            case 'setPerson':
                return { ...state, person: action.person };
            case 'setPeriode':
                return { ...state, person: action.periode };
            case 'addOptions':
                return { ...state, options: state.options.concat(action.options) };
            case 'removeOptions':
                //return { ...state, options: state.options.filter(option => option.id !== action.id) };
                return { ...state, options: [] };
            default:
                return state;
        }
    };
    return store = createStore(baseState, reducer);
}

export function initReservation()
{
    // Gère les dates
    const inputStart = document.querySelector('.js-date-start') || null;
    const inputEnd = document.querySelector('.js-date-end') || null;
    const inputPerson = document.querySelector('.js-person') || null;

    if(!(inputStart) || !(inputEnd) || !(inputPerson)) return;

    const defaultPrice = Number(document.querySelector("#defaut_price").value);
    const defaultFrais = Number(document.querySelector("#defaut_sejour").value);
    const defaultTaxe = Number(document.querySelector("#defaut_taxe").value);

    const initialState = {
        periode: 0,
        days : 1,
        price: defaultPrice,
        frais: defaultFrais,
        taxe: defaultTaxe,
        person: 1,
        options: []
    };

    const store = initState(initialState);

    const instanceStart = initFlatPickr(inputStart, {});
    const instanceEnd = initFlatPickr(inputEnd, {});

    // reset field 
    instanceStart.clear();
    instanceEnd.clear();
    inputPerson.value = 1;

    instanceEnd._input.disabled = true;
    instanceStart.config.onChange.push(function(selectedDates, dateStr, instance) {
        // Lancer requete ajax
        instanceEnd.clear();
        resetRecapReservation();
        requestPeriode('reservations', dateStr, function(data){
            if(data.scolaire === true)
            {
                store.dispatch({ type: 'setPeriode', periode: 1 });
            }
            //store.dispatch({ type: 'setPrice', price: data.defaut_price });
            instanceEnd.set('minDate', new Date(dateStr).addDays(data.nb_jours));
            instanceEnd._input.disabled = false;
        });
    });

    instanceEnd.config.onChange.push(function(selectedDates, dateStr, instance) {
        if(dateStr === "") return;
        let start = new Date(instanceStart.selectedDates);
        let startDay = start.getDate();
        let startMonth = start.getMonth();
        let startYear = start.getFullYear();
        start = startYear + "-" + (startMonth + 1) + "-" + startDay;
        const end = dateStr;
        instanceEnd.set('minDate', new Date(start).addDays(1));
        // Ajax Request
        requestForDetailsReservation("reservations_end", start, end, function(data){
            const recap = document.querySelector(".reservation-recap-details");
            recap.innerHTML = "";
            const weeks = data.details;
            for (const [key, value] of Object.entries(weeks)) {
                weekTitle = key.replace("_", " ");
                weekTotal = weeks[key]["Prix_total_avec_réduction"];
                weekNbJours = weeks[key]["Total_jours"];
                weekReduc = weeks[key]["Réduction"];

                let element = createWeekElement(weekTitle, weekTotal, weekNbJours, weekReduc);
                recap.appendChild(element);
            }

            store.dispatch({ type: 'setPrice', price: (data["Prix_total"] * 100) });
            store.dispatch({ type: 'setDays', days: data["Nombre_de_jours"] });
        });
    });

    inputPerson.addEventListener('change', function(e) {
        store.dispatch({ type: 'setPerson', person: Number(e.target.value) });
    });

    // Gère les options
    //manageOption();
    manageOptions();
}

function manageOptions()
{
    // Custom select multiple
    const customSelectMultiple = document.querySelectorAll('.clbs-custom-select');
    if(isDefined(customSelectMultiple))
    {
        customSelectMultiple.forEach(select => {
            new ClbsCustomMulipleSelect(select, function(e)
            {
                const selected = e.target.querySelectorAll('option:checked');
                store.dispatch({ type: 'removeOptions'});
                if(!isDefined(selected)) return;
                selected.forEach(function(option){
                    const optionId = option.dataset.optionId;
                    const optionLabel = option.dataset.optionLabel;
                    const optionPrice = option.dataset.optionPrice;
                    // Cree un tableau qui merge les variables de l'option avec l'id en clé
                    const optionData = { id: optionId, label: optionLabel, price: optionPrice };
                    store.dispatch({ type: 'addOptions', options: optionData });
                });
            });
        });
    }
}

function initFlatPickr(input, options = {})
{
    let disabledDates = input.getAttribute('data-disabled-dates') || null;
    let holidaysDates = document.querySelector("#date_holidays").value || null;
    let maxDate = document.querySelector("#max_calendar").value || 365;

    let config = {
        dateFormat: "Y-m-d",
        altInput: true,
        locale:"fr",
        altFormat: "d F Y",
        minDate: "today",
        disableMobile: "true",
        maxDate: new Date().fp_incr(maxDate),
        wrap: true,
    }

    if(disabledDates !== null) {
        disabledDates = JSON.parse(disabledDates);
        config = Object.assign(config, {
            disable: disabledDates,
        });
    }

    if(holidaysDates)
    {
        holidaysDates = JSON.parse(holidaysDates);
        config = Object.assign(config, {
            onDayCreate: function(dObj, dStr, fp, dayElem) {
                let calendarDate = dayElem.dateObj;
                let key = getDateKey(fp.currentYear, getMonth(fp.currentMonth, dayElem.className), dayElem.textContent);
                if(holidaysDates.includes(key))
                {
                    dayElem.className += " holiday";
                }
            }
        });
    }
    config = Object.assign(config, options);
    return flatpickr(input, config);
}

async function requestPeriode(action, date, callback)
{
    const formData = new FormData();
    formData.append( 'action', action );
    formData.append( 'date-arrivee', date );
    if(typeof ajax_var != "undefined" && ajax_var.nonce) formData.append( 'nonce', ajax_var.nonce);

    await fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        credentials: 'same-origin',
        body: formData
    })
    .then(function(response){
        if(response.ok) { 
            return response.json();
        }
        throw new Error('Network response was not ok.');
    })
    .then(function(data){
        callback(data);
    })
    .catch(function(error) {
        console.log('There has been a problem with your fetch operation: ' + error.message);
    });
}

function resetRecapReservation()
{
    const recap = document.querySelector(".reservation-recap-details");
    recap.innerHTML = "";
    let element = createWeekElement("Semaine 1", "0", "0");
    recap.appendChild(element);
}

async function requestForDetailsReservation(action, dateStart, dateEnd, callback)
{
    const formData = new FormData();
    formData.append( 'action', action );
    formData.append( 'date-arrivee', dateStart );
    formData.append( 'date-depart', dateEnd );
    if(typeof ajax_var != "undefined" && ajax_var.nonce) formData.append( 'nonce', ajax_var.nonce);

    await fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        credentials: 'same-origin',
        body: formData
    })
    .then(function(response){
        if(response.ok) { 
            return response.json();
        }
        throw new Error('Network response was not ok.');
    })
    .then(function(data){
        callback(data);
    })
    .catch(function(error) {
        console.log('There has been a problem with your fetch operation: ' + error.message);
    });
}

// Création d'une élément dans la partie récapitulatif
function createWeekElement(title, price, days, reduc = null)
{
    const li = document.createElement('li');
    li.classList.add('reservation-recap-details-item');

    const spanWrapper = document.createElement('span');
    spanWrapper.classList.add('reservation-recap-details-item-title');

    const spanWeek = document.createElement('span');
    spanWeek.classList.add('reservation-recap-details-item-title-week');
    spanWeek.textContent = title + " : ";
    spanWrapper.appendChild(spanWeek);

    const spanPrice = document.createElement('span');
    spanPrice.classList.add('reservation-recap-details-item-title-price');
    spanPrice.textContent = price + " €";
    spanWrapper.appendChild(spanPrice);

    const spanDays = document.createElement('span');
    spanDays.classList.add('reservation-recap-details-item-title-days');
    spanDays.textContent = ` (${days} nuits)`;
    spanWrapper.appendChild(spanDays);

    li.appendChild(spanWrapper);

    if(reduc)
    {
        const divReduc = document.createElement('div');
        divReduc.classList.add('reservation-recap-details-item-reduc');
        divReduc.textContent = "Réduction 10% appliquée";
        li.appendChild(divReduc);
    }

    return li;
}
